"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Assignment {
    constructor() {
        this.id = undefined;
        this.type = "";
        this.title = "";
        this.url = "";
        this.resource_id = "";
        this.lineitem_score_maximum = "";
        this.lineitem_label = "";
        this.lineitem_resource_id = "";
        this.lineitem_tag = "";
        this.lineitems = "";
        this.context_id = "";
    }
}
exports.default = Assignment;
